module.exports = App.OrderSummaryPanelComponent = Em.Component.extend
  classNames: [ 'order-summary-panel' ]

  isDiscountSumNegative: (->
    @get('order.discount_sum') < 0
  ).property('order.discount_sum')

  absoluteDiscountSum: (->
    Math.abs @get('order.discount_sum')
  ).property('order.discount_sum')

  hasServiceCharge: (->
    !!Number(@get('order.service_charge_amount'))
  ).property('order.service_charge_amount')